import { decreaseLoading, increaseLoading } from './loading';
import ProductsApi from '~/repositories/products';
import * as MessageService from '~/services/message';
import {
  PRODUCTS_ALREADY_CREATED_ESCROW_ACCOUNT,
  PRODUCTS_ESCROW_ACCOUNT,
  PRODUCTS_ESCROW_TRANSACTIONS,
  PRODUCTS_LIMIT_SOLICITATIONS,
} from './actionTypes';

export const alreadyCreatedEscrowAccount = () => async (dispatch) => {
  dispatch(increaseLoading());
  try {
    const payload = await ProductsApi.alreadyCreatedEscrowAccount();

    dispatch({
      payload: payload,
      type: PRODUCTS_ALREADY_CREATED_ESCROW_ACCOUNT,
    });
  } catch (err) {
    if (err instanceof Error) {
      MessageService.error(err.message, { originalError: err });
    }
  } finally {
    dispatch(decreaseLoading());
  }
};

export const createEscrowAccount =
  (body: { accountId: string }) => async (dispatch) => {
    dispatch(increaseLoading());
    try {
      await ProductsApi.createEscrowAccount(body);
    } catch (err) {
      if (err instanceof Error) {
        MessageService.error(err.message, { originalError: err });
      }
    } finally {
      dispatch(decreaseLoading());
    }
  };

export const getEscrowAccount = () => async (dispatch) => {
  dispatch(increaseLoading());
  try {
    const payload = await ProductsApi.getEscrowAccount();

    dispatch({
      payload,
      type: PRODUCTS_ESCROW_ACCOUNT,
    });
  } catch (err) {
    if (err instanceof Error) {
      MessageService.error(err.message, { originalError: err });
    }
  } finally {
    dispatch(decreaseLoading());
  }
};

export const getEscrowTransactions =
  (filters: advancedFilterModels.baseFilter) => async (dispatch) => {
    dispatch(increaseLoading());
    try {
      const payload = await ProductsApi.getEscrowTransactions(filters);

      dispatch({
        payload,
        type: PRODUCTS_ESCROW_TRANSACTIONS,
      });
    } catch (err) {
      if (err instanceof Error) {
        MessageService.error(err.message, { originalError: err });
      }
    } finally {
      dispatch(decreaseLoading());
    }
  };

export const createLimitSolicitation =
  (body: { reason: string; amount: number }) => async (dispatch) => {
    dispatch(increaseLoading());
    try {
      await ProductsApi.createLimitSolicitation(body);
    } catch (err) {
      if (err instanceof Error) {
        MessageService.error(err.message, { originalError: err });
      }
    } finally {
      dispatch(decreaseLoading());
    }
  };

export const getLimitSolicitations = () => async (dispatch) => {
  dispatch(increaseLoading());
  try {
    const payload = await ProductsApi.getLimitSolicitations();

    dispatch({
      payload,
      type: PRODUCTS_LIMIT_SOLICITATIONS,
    });
  } catch (err) {
    if (err instanceof Error) {
      MessageService.error(err.message, { originalError: err });
    }
  } finally {
    dispatch(decreaseLoading());
  }
};
